import { axiosBase } from "utils";

export function branchcustomerListService(page, sorting) {
  const axios = axiosBase.create();
  let params = [];
  params.push(`page=${page}`);
  if (sorting && sorting !== "") {
    params.push(`sort=${sorting}`);
  }
  return axios({
    method: "GET",
    //url: "/branchcustomer?" + params.join("&"),
    url: "/branchcustomer",
  });
}

export function branchcustomerIndexListingService(page, sorting) {
  const axios = axiosBase.create();
  let params = [];
  params.push(`page=${page}`);
  if (sorting && sorting !== "") {
    params.push(`sort=${sorting}`);
  }
  return axios({
    method: "GET",
    url: "/branchcustomer/index-listing",
  });
}

export function branchcustomerDropdownService() {
  const axios = axiosBase.create();
  return axios({
    method: "GET",
    url: "/branchcustomer/dropdown",
  });
}

export function branchcustomerListByIdService(id) {
  const axios = axiosBase.create();
  return axios({
    method: "GET",
    url: "/branchcustomer/" + id,
  });
}

export function branchcustomerListByBranchNetworkIdService(id) {
  const axios = axiosBase.create();
  return axios({
    method: "GET",
    url: "/branchcustomer/list-by-branchnetwork/" + id,
  });
}

export function branchcustomerCreateService(values) {
  const axios = axiosBase.create();
  return axios({
    method: "POST",
    url: "/branchcustomer",
    data: {
      branchnetwork: values.branchnetwork,
      public_branch_client: values.public_branch_client ? "Y" : "N",
      accountnumber: values.accountnumber,
      vlantype: values.vlantype,
      customvlan_value: values.customvlan_value,
      customername: values.customername,
      customercontact: values.customercontact,
      customerphone: values.customerphone,
      customeremail: values.customeremail,
      hasfirewall: values.hasfirewall ? "Y" : "N",
      customerOfficeNumbers: values.customerOfficeNumbers,
      showInDirectory: values.showInDirectory ? "Y" : "N",

      firewallmodel: values.firewallmodel,
      firewallvendor: values.firewallvendor,
      firewallserial: values.firewallserial,
      firewallratelimit: values.firewallratelimit,
      equipmentownership: values.equipmentownership,

      notes: values.notes,
    },
  });
}

export function branchcustomerUpdateService(id, values) {
  const axios = axiosBase.create();
  return axios({
    method: "PATCH",
    url: "/branchcustomer/" + id,
    data: {
      //branchnetwork: values.branchnetwork, // on update not allowed to update branch network
      public_branch_client: values.public_branch_client ? "Y" : "N",
      accountnumber: values.accountnumber,
      vlantype: values.vlantype,
      customvlan_value: values.customvlan_value,
      customername: values.customername,
      customercontact: values.customercontact,
      customerphone: values.customerphone,
      customeremail: values.customeremail,
      hasfirewall: values.hasfirewall ? "Y" : "N",
      customerOfficeNumbers: values.customerOfficeNumbers,
      showInDirectory: values.showInDirectory ? "Y" : "N",

      firewallmodel: values.firewallmodel,
      firewallvendor: values.firewallvendor,
      firewallserial: values.firewallserial,
      firewallratelimit: values.firewallratelimit,
      equipmentownership: values.equipmentownership,

      notes: values.notes,
    },
  });
}

export function branchcustomerDeleteService(id) {
  const axios = axiosBase.create();
  return axios({
    method: "DELETE",
    url: "/branchcustomer/" + id,
  });
}

export function branchcustomerSendPrintEmailService(id, email) {
  const axios = axiosBase.create();
  return axios({
    method: "POST",
    url: "/branchcustomer/" + id + "/send-print-email",
    data: { email },
  });
}

export function branchcustomerSearchService(q, paginationPayload) {
  const axios = axiosBase.create();
  let paginationQuery = "";
  if (paginationPayload) {
    paginationQuery = new URLSearchParams(paginationPayload).toString();
  }
  if (q === "") {
    return axios({
      method: "GET",
      url: "/branchcustomer?" + paginationQuery,
    });
  } else {
    return axios({
      method: "GET",
      url: "/branchcustomer/search?q=" + q + "&" + paginationQuery,
    });
  }
}
